module.exports = __webpack_public_path__ + "static/media/analytics.0af8bc71.svg";